<nav class="navbar navbar-expand-lg navbar-dark bg-danger">
  <a class="navbar-brand" [routerLink]="['/']">
    <img src="../../../assets/img.png" alt="img" width="30" height="30" />

    Github User Finder
  </a>

  <div class="navbar-collapse">
    <div class="navbar-nav ml-auto">
      <div *ngIf="email" class="navbar-text float-left">
        {{ email }}
      </div>
      <a
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/']"
        class="nav-item nav-link"
        >Home</a
      >
      <a
        routerLinkActive="active"
        [routerLink]="['/signin']"
        *ngIf="!email"
        [routerLinkActiveOptions]="{ exact: true }"
        class="nav-item nav-link"
        >Signin</a
      >
      <a
        routerLinkActive="active"
        [routerLink]="['/signup']"
        [routerLinkActiveOptions]="{ exact: true }"
        *ngIf="!email"
        class="nav-item nav-link"
        >Signup</a
      >
      <a *ngIf="email" (click)="handleSignOut()" class="nav-item nav-link"
        >Logout</a
      >
    </div>
  </div>
</nav>
